export class WasmAdapter {
    static create(module, wasmFile) {
        var _a;
        let webDir;
        if (typeof document != 'undefined') {
            webDir = (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.src;
            if (webDir)
                webDir = webDir.substring(0, webDir.replace(/[?#].*/, "").lastIndexOf("/") + 1);
        }
        return () => {
            let moduleArg = {};
            if (WasmAdapter.instantiateWasm != null) {
                moduleArg["instantiateWasm"] = function (imports, receiveInstance) {
                    return WasmAdapter.instantiateWasm(wasmFile, imports).then(exports => {
                        receiveInstance(exports["instance"]);
                        return exports;
                    });
                };
            }
            moduleArg["locateFile"] = function (path, scriptDirectory) {
                if (WasmAdapter.locateFile != null)
                    wasmFile = WasmAdapter.locateFile(path, scriptDirectory, webDir);
                else
                    wasmFile = scriptDirectory + path;
                return wasmFile;
            };
            return module(moduleArg);
        };
    }
}
WasmAdapter.Memory = typeof (WebAssembly) !== "undefined" ? WebAssembly.Memory : null;
